import { useFlow } from "../../../FlowEdit/useFlow";
import { Switch } from "antd";
import { RenderInputProps } from "../types";

/**
 * Switch
 */
export default function ({ moduleId, item }: RenderInputProps) {
  const { updateNodeValue } = useFlow();

  return (
    <Switch
      defaultValue={item.value === "true" ? true : false}
      onChange={(checked: boolean) => {
        updateNodeValue(moduleId, item.key, `${checked}`);
      }}
    />
  );
}
